export default __webpack_public_path__ + "static/media/bg1.d2d71223.png";